/*****************
 * GA4
 */

dataLayer.push({ecommerce: null});
dataLayer.push({
    event: "view_item",
    ecommerce: {
        currency: Shopify.currency.active,
        price: activeVariant.price / 100,
        items: [
            {
                item_id: product.id,
                item_name: product.title,
                item_variant: activeVariant.title,
                item_category: product.type,
                price: activeVariant.price / 100,
                quantity: 1
            }
        ]
    }
});

/*****************
 * Product Reviews
 * *************/

if (window.ratingSnippet && (product.handle === "waterguru-sense" || product.handle === "waterguru-sense-sale")) {
    ratingSnippet("productStars", {
        store: "waterguru.com",
        color: "#fab101",
        linebreak: true,
        usePolaris: true,
        text: "Reviews",
        min_rating: 4,
    });
}

document.querySelectorAll('.productV4Stars').forEach(function (element) {
    element.addEventListener("click", function () {
        window.scroll({
            behavior: "smooth",
            top: document.querySelector("#productV4Reviews").offsetTop
        })
    })
})

/*****************
 * Product Bundles
 * *************/

document.querySelector("#productV4BundlesATC")?.addEventListener("click", async function () {
    // add loading animation
    this.classList.add("loading");

    let formData = {
        items: [{
            quantity: parseInt(document.querySelector(`.productV4BundlesItemInput:checked`).value),
            id: activeVariant.id,
        }]
    };

    // add deliveryType as a property if found in the url
    if (urlParams.get("deliveryType")) {
        formData.items[0].properties = {};
        formData.items[0].properties._deliveryType = urlParams.get("deliveryType");
    }

    // add product
    await addProduct(formData);

    // open cart
    await openCart();

    // GA4
    dataLayer.push({ecommerce: null});
    dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
            subscription_included: false,
            value: activeVariant.price * quantity / 100,
            currency: Shopify.currency.active,
            items: [{
                item_id: product.id,
                item_name: product.title,
                item_variant: activeVariant.title,
                item_category: product.type,
                price: activeVariant.price / 100,
                quantity: quantity,
                subscription_item: false,
            }]
        }
    });

    // remove loading animation
    this.classList.remove("loading");
});


/*************
 Adapters
 ************/

if (document.querySelector("#productV4Adapters")) {
    // preload all images
    Object.values(adapters).forEach(function (adapter) {
        preloadImage(adapter.media[adapter.media.length - 1].src)
    });

    // event listener for change
    document.querySelector("#productV4AdaptersSelect").addEventListener("change", function () {
        /*
        NOTE, adapter is undefined when we're looking at the DEFAULT product
        For example, when the adapter dropdown is set to its original position and there are no addons
         */

        // get adapter
        let adapter = adapters[this.value];

        // determine which image to use
        let image;
        if (adapter === undefined) {
            // first image is used for the default product
            image = product.featured_image;
        } else {
            // adapter products we use the last image
            image = adapter.media[adapter.media.length - 1].src;
        }

        // update image and thumbnail
        document.querySelector(".productV4VisualSwiperImage").src = `${image}&width=1000`;
        document.querySelector(".productV4VisualThumbnailsImage").src = `${image}&width=200`;

        // determine price
        let priceVal;
        if (adapter === undefined) {
            priceVal = product.price;
        } else {
            priceVal = product.price + adapter.price;
        }

        // update price
        document.querySelector("#productV4SummaryPriceMain").textContent = price(priceVal);

        // change slider to position on
        productImages.slideTo(0);
    });
}

/**************
 Product Subscriptions
 ***************/

// when subscription is changed, update pricing
document.querySelectorAll(".productV4SubscriptionLabelInput").forEach(function (element) {
    element.addEventListener("change", function () {
        // check for shadow products
        if (shadowProducts.length > 0) {
            const isSubscription = document.querySelector("#productV4Subscribe:checked") !== null;
            const subscriptionSavings = (1 - (activeVariant.selling_plan_allocations[0].price / activeVariant.selling_plan_allocations[0].compare_at_price)).toFixed(2) * 100;
            document.querySelector("#productV4SummaryPricePercent").textContent = `Save ${isSubscription ? subscriptionSavings : "5"}% OFF`;
            document.querySelector("#productV4SummaryPriceMain").textContent = price(isSubscription ? activeVariant.selling_plan_allocations[0].price : activeVariant.price * 0.95);

            // ugly price overrides
            document.querySelector("#productV4SummaryPriceMain").textContent = document.querySelector("#productV4SummaryPriceMain").textContent
                .replace("93.19", "93.18")
                .replace("83.39", "83.38")
                .replace("201.84", "201.83")
                .replace("225.59", "225.58");
        } else {
            // update price
            document.querySelector("#productV4SummaryPriceMain").textContent = price(activeVariant.price);

            // check for compare at price
            if (activeVariant.price < activeVariant.compare_at_price) {
                document.querySelector("#productV4SummaryPriceCompare").textContent = price(activeVariant.compare_at_price);
            }
        }
    });
});

/****************
 * Product Quantity
 **************/

// initialize quantity
let quantity = 1;

// quantity is not rendered on sense template
if (document.querySelector("#productV4SummaryQuantity")) {
    // minus
    document.querySelector("#productV4SummaryQuantityMinus").addEventListener("click", function () {
        // must not be less than 1
        if (quantity === 1) {
            return;
        }

        // decrement by 1
        quantity--;
        document.querySelector("#productV4SummaryQuantityValue").textContent = quantity;
    });

    // plus
    document.querySelector("#productV4SummaryQuantityPlus").addEventListener("click", function () {
        // limit quantity
        if (productToMaxQuantity[product.id] && quantity >= productToMaxQuantity[product.id]) {
            return;
        }

        // increment by 1
        quantity++;
        document.querySelector("#productV4SummaryQuantityValue").textContent = quantity;
    });
}

/**************
 Product ATC
 ***************/

document.querySelector("#productV4SummaryATC")?.addEventListener("click", async function () {
    // add loading animation
    document.querySelector("#productV4SummaryATC").classList.add("loading");

    let formData = {
        items: [{
            quantity: quantity,
            id: activeVariant.id,
        }]
    };

    // check for subscription
    const isSubscription = document.querySelector("#productV4Subscribe:checked") !== null;
    if (isSubscription) {
        formData.items[0].selling_plan = product.selling_plan_groups[0].selling_plans[0].id;
    }

    // check for adapters product
    if (document.querySelector("#productV4AdaptersSelect") && document.querySelector("#productV4AdaptersSelect").value !== "0") {
        formData.items.unshift({
            quantity: 1,
            id: adapters[document.querySelector("#productV4AdaptersSelect").value].variants[0].id
        });
    }

    // check if there are shadow products
    if (shadowProducts.length > 0) {
        // override items
        formData.items = formData.items = JSON.parse(JSON.stringify(shadowProducts));

        // check if we should remove the selling_plan since they're already included in the shadow products
        if (!isSubscription) {
            for (let i = 0; i < formData.items.length; i++) {
                delete formData.items[i].selling_plan;
            }
        }
    }

    // add deliveryType as a property if found in the url
    if (urlParams.get("deliveryType")) {
        // loop through all items
        for (let i = 0; i < formData.items.length; i++) {
            // check if properties exist
            if (!formData.items[i].properties) {
                formData.items[i].properties = {};
            }

            // add deliveryType
            formData.items[i].properties._deliveryType = urlParams.get("deliveryType");
        }
    }

    // add product
    await addProduct(formData);

    // open cart
    await openCart();

    // GA4
    dataLayer.push({ecommerce: null});
    dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
            subscription_included: document.querySelector("#productV4Subscribe:checked") !== null,
            value: activeVariant.price * quantity / 100,
            currency: Shopify.currency.active,
            items: [{
                item_id: product.id,
                item_name: product.title,
                item_variant: activeVariant.title,
                item_category: product.type,
                price: activeVariant.price / 100,
                quantity: quantity,
                subscription_item: document.querySelector("#productV4Subscribe:checked") !== null,
            }]
        }
    });

    // remove loading animation
    document.querySelector("#productV4SummaryATC").classList.remove("loading");
});

/************************
 Chemical Shipping
 ********************/

// update shipping method
if (document.querySelector("#productV4Shipping")) {
    if (urlParams.get("deliveryType") === "branch") {
        document.querySelector("#productV4Shipping").innerHTML = `This item is for same day delivery. Free Delivery on $99 chemical orders.`;
    } else if (urlParams.get("deliveryType") === "distributionCenter") {
        document.querySelector("#productV4Shipping").innerHTML = `This item is for standard delivery. Free Delivery on $99 chemical orders.`;
    } else {

        const returnParams = new URLSearchParams({
            return_url: window.location.pathname,
            return_sku: activeVariant.sku,
        })

        // redirect to collection page since deliveryType is not found
        if (product.tags.includes("spa")) {
            window.location.href = `/collections/for-spas?${returnParams}`;
        } else {
            window.location.href = `/collections/for-pools?${returnParams}`;
        }
    }
}

/********************
 Product OOS
 *******************/

document.querySelector("#productV4OOS")?.addEventListener("submit", async function (e) {
    // prevent default
    e.preventDefault();

    // start loading
    document.querySelector("#productV4OOSFormSubmit").classList.add("loading");

    // add to waitlist
    await sendKlaviyoBackInStockRequest(document.querySelector("#productV4OOSFormEmail").value, activeVariant.id)

    // success
    document.querySelector("#productV4OOSTitle").textContent = `Thank You. We will notify you when item is back in stock.`;
    document.querySelector("#productV4OOSSubtitle").remove();
    document.querySelector("#productV4OOSFormEmail").remove();
    document.querySelector("#productV4OOSFormSubmit").remove();
});